const BASE = "https://thanks.io/?afmc=ahx";

export const AFFILIATE_URL = BASE;

// Attach UTM tags per placement so we can attribute conversions in Thanks.io analytics
export const cta = (medium) =>
  `${BASE}&utm_source=postmarkco&utm_medium=${encodeURIComponent(medium)}&utm_campaign=landing`;

export const BRAND = {
  name: "Postmark",
  wordmark: "Postmark & Co.",
  tagline: "A love letter to direct mail.",
};
